import { Component, OnInit } from '@angular/core';
import { OfficeStatus } from '../../../../../../shared/office-status';
import { FruHttpService } from '../../../../../../services/fru-http.service';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../../../../../services/analytics.service';
import { BrandService } from '../../../../../../services/brand.service';

@Component({
    selector: 'app-mmlanding-body',
    templateUrl: './mmlanding-body.component.html',
    styleUrls: ['../../fru/form-landing-body/form-landing-body.component.scss'],
    standalone: false
})
export class MMLandingBodyComponent implements OnInit {
  officeStatus: OfficeStatus;
  headerText: String;
  showProgressBar:boolean;
  showTop10:boolean;
  state: string = '';

  constructor(
    private fruHttp: FruHttpService,
    private router: Router,
    private analyticsService: AnalyticsService,
    private brandService: BrandService
  ) {
    this.showProgressBar = true;
    this.showTop10 = false;
  }

  ngOnInit() {
  }

  redirectForm(type: string, formType?: string, maxCash?: string) {

    let qp = {};
    qp['LoanPurpose'] = type;

    if (formType) {
      qp['FormType'] = formType;
    }

    if (maxCash) {
      qp['maxCashoutForm'] = maxCash;
    }

    this.analyticsService.trackQuestionAnswered();
    this.router.navigate(['/rates-form'], { queryParams: qp, queryParamsHandling: 'merge' });
  }

  adDisclosurePopup() {
    this.fruHttp.adDisclosurePopup();
  }

}
